import React from "react";
import resources from "../../../../api/constants/resources";
import { useProductPageType } from "@hook/products/useProductPageTypeHandler";
import ProductsList from "@components/products/list/ProductsList";
import ProductsDetail from "@components/products/detail/ProductsDetail";
import axios from "axios";
import { seoSettingSSR } from "@api/seo";

const ProductHashPage = ({
  product,
  seoData,
  initialPage,
  userDevice,
  siteConfig,
}) => {
  const { isDetailPage, lastSlug } = useProductPageType();

  return (
    <>
      {isDetailPage ? (
        <ProductsDetail
          seoData={seoData}
          product={product}
          userDevice={userDevice}
        />
      ) : (
        //2차 카테고리
        <ProductsList
          seoData={seoData}
          product={product}
          userDevice={userDevice}
          initialPage={initialPage}
          siteConfig={siteConfig}
        />
      )}
    </>
  );
};

export default ProductHashPage;

export const getServerSideProps = async (context) => {
  const { params } = context;
  const slug = params.slug;
  const hash = params.hash;

  // SEO 작업
  let seoData = null;
  try {
    if (slug) {
      const seoResponse = await seoSettingSSR(slug);
      seoData = seoResponse.data.Data;
    }
  } catch (error) {
    console.error("SEO 데이터 가져오기 실패:", error);
  }

  //제품 데이터 가져오기
  const body = new URLSearchParams();
  body.append("modes", "View");
  body.append("pcode", hash); // 제품 ID 사용
  try {
    const res = await axios.post(`${resources.PRODUCTS}`, body.toString(), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    if (res.data.Code === "0000") {
      return {
        props: {
          product: { ...res.data.Data.Row },
          seoData: seoData || null,
        },
      };
    } else {
      return {
        props: {
          seoData: seoData || null,
        },
      };
    }
  } catch (error) {
    console.error(error);
    return {
      props: {
        seoData: seoData || null,
      },
    };
  }
};
